
<template>
  <div>
    <v-card flat style="border-radius:12px">
      <v-card-title primary-title>
        <div class="headline mb-0">Consolidação</div>
      </v-card-title>
      <v-card-text>
        <!-- {{consolidation}} -->
        <model-1 :execution="execution" v-if="is_model_1"></model-1>
        <model-2 :execution="execution" v-if="is_model_2"></model-2>
      </v-card-text>
      <!-- <v-card-actions class="justify-end" v-if="false">
        <v-btn flat text color="error">Cancelar</v-btn>
        <v-btn flat text color="primary">OK</v-btn>
      </v-card-actions> -->
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: "ShowConsolidationComp",
  components: {
    Model1:()=>import('./model_1/Model1.vue'),
    Model2:()=>import('./model_2/Model2.vue'),
  },
  data() {
    return {
      consolidation: null,
      execution: null,
    }
  },
  methods: {
    getExecution() {
      Api.Execution.show(this.$route.params.id).then(r=>r.data).then(d=>{
        this.execution = {...d}
      })
    },
    
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getExecution();
  },
  computed: {
    is_model_1(){
      if (this.execution){
        return this.execution.kind == 'model_1'
      }
      return false
    },
    is_model_2(){
      if (this.execution){
        return this.execution.kind == 'model_2'
      }
      return false
    },
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>